import { useRef, useEffect } from 'react'
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { useQuery } from '@tanstack/react-query'

// store
// import useAuthStore from '../../store/auth';
import useAuth from '../../hooks/useAuth'

// Form Validation
import {object, string} from 'yup'

// Form Components
import { Form, Formik, FieldArray } from "formik";
import Field from '../../utils/FormikFields/Field';
import { Button, CircularProgress, FormHelperText } from '@mui/material';
import ExitToAppRoundedIcon from '@mui/icons-material/ExitToAppRounded';     
      


// Form Field Icons
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import Lock from '../../images/lock';
import NovoSalonLogo from '../../images/novosalon-logo.svg'
import Logo from '../../images/schedule-58.png'

import { Container, Legal, Title, SubTitle, LogoBox } from './commonStyles'

import { Grid, Row } from '../../utils/Grid'

const Forget = styled.span`
  display: block;
  width: 100%;
  color: ${props => props.theme.colors.lightText};
  margin-top: 1.5rem;
  text-align: right;
  font-weight: 500;
`

const StyledForm = styled(Form)`
  width: 100%;
`;

export const Signin = ({handleSubmit, isLoading}) => {

  const emailRef = useRef(null);

    const initialValues = {
      email: "",
      password: "",
    }

    const schema = object().shape({
      password: string().required("Password is Required"),
      email: string().email().required("Email is Required"),
    })

    useEffect(() => {
      if (emailRef.current) {
        emailRef.current.focus();
      }
    }, []);

  return (
    <Container>
    <Title>
        Hi, Welcome back
      </Title>
      <SubTitle>Please sign in to your account</SubTitle>
      <LogoBox>
        <img src={NovoSalonLogo} alt="logo graphic" />
      </LogoBox>
      
      <Formik initialValues={initialValues} validationSchema={schema} onSubmit={handleSubmit} enableReinitialize>
        {(propBag) => (
          <StyledForm>
          <Grid>
            <Row>
              <Field name="email" inputRef={emailRef} size="large" label="Email" showSuccess type="email" InputProps={{endAdornment: <EmailRoundedIcon color="icon" />}} />
            </Row>
            <Row>
              <Field name="password" size="large" label="Password" showSuccess InputProps={{endAdornment: <LockRoundedIcon color="icon" />}} type="password" />
            </Row>
            <Row>
              {propBag?.errors?._error && <FormHelperText error>* {propBag?.errors?._error}</FormHelperText>}
            </Row>
            <Row>
              <Forget>Forgot Password?</Forget>
            </Row>
            <Row>
              <Button type="submit" fullWidth variant="contained" loading={isLoading ? true : false} loadingPosition="start" size="large" startIcon={<ExitToAppRoundedIcon />}
              sx={{ py: "1.5rem", mt: "1rem", gap: "1rem" }}
              >Sign In</Button>
            </Row>
          </Grid>
        </StyledForm>
        )}
      </Formik>
      <Legal>
        &copy; Novosoft 2023 | All Rights Reserved
      </Legal>
    </Container>
  )
}
